/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import dayjs from "dayjs";

import { CustomerAPIClient } from "../api_clients";
import Address from "../models/address";
import { IAuthContext } from "../providers/CognitoAuthProvider";

const getAddressByAPIResponse = (address: any) => {
  if (address == null) {
    return null;
  }
  return {
    id: address.id,
    address: address.address,
    code: address.code,
    lat: address.lat,
    lng: address.lng,
    name: address.name ? address.name : "自宅",
    type: address.type,
    typeName: address.type_name,
  };
};

const getPaginateByAPIResponse = (data: any) => {
  if (data == null) {
    return {
      currentPage: 0,
      totalPages: 0,
      totalCount: 0,
    };
  }
  return {
    currentPage: data.paginate.current_page,
    totalPages: data.paginate.total_pages,
    totalCount: data.paginate.total_count,
  };
};

const getAddressesByAPIResponse = (addresses: any) =>
  addresses.map((x: any) => {
    const address = getAddressByAPIResponse(x);
    return {
      ...address,
      startDate: dayjs(x.start_date),
      endDate: dayjs(x.end_date),
    };
  });

export const getAddresses = async (
  auth: IAuthContext,
  workplaceName: string,
  page: number | null
) => {
  const urlPath = `/api/addresses/?type=partner,flapgate&limit=10&q=${workplaceName}${
    page === null || page === 0 ? "" : `&page=${page}`
  }`;
  const addresses = await CustomerAPIClient.get(auth, urlPath);

  const datas = addresses.datas.reduce(
    (acc: Address[], address: any) => [
      ...acc,
      getAddressByAPIResponse(address),
    ],
    []
  );

  return {
    ...getPaginateByAPIResponse(addresses),
    datas,
  };
};

export const getUserAddress = async (auth: IAuthContext) =>
  getAddressByAPIResponse(
    await CustomerAPIClient.get(auth, "/api/users/address")
  );

export const getUserAddresses = async (auth: IAuthContext) =>
  getAddressesByAPIResponse(
    await CustomerAPIClient.get(auth, "/api/users/addresses")
  );
/* eslint-enable */
